import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getUserDetail = async (id) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/user/${id}`,
  });

  return data?.data;
};

export default getUserDetail;
